'use client';

import { useDateFormatter } from '@terra/ui-formatters';
import { useTranslations } from 'next-intl';
import { MetaDefault } from '../../../components/typography';
import type { InternalNetworkCredentialVerificationStatus } from './internal-credentials.model';

type InternalNetworkCredentialVerificationInfoProps = {
  verificationStatus: InternalNetworkCredentialVerificationStatus;
  verifiedAt?: string | null;
  isTesting?: boolean;
};

export const InternalNetworkCredentialVerificationInfo = ({
  verificationStatus,
  verifiedAt,
  isTesting,
}: InternalNetworkCredentialVerificationInfoProps) => {
  const t = useTranslations('designSystem.credentials.card');
  const dateFormatter = useDateFormatter();

  if (isTesting) {
    return null;
  }

  if (verificationStatus === 'VERIFIED' && verifiedAt) {
    return (
      <MetaDefault color="fg.neutral.muted">
        {`${t('verifiedAt')} ${dateFormatter.format(new Date(verifiedAt))}`}
      </MetaDefault>
    );
  }

  if (verificationStatus === 'FAILED') {
    return (
      <MetaDefault color="fg.neutral.muted">{t('failedVerify')}</MetaDefault>
    );
  }

  return null;
};
